import { AppThunkAction } from "..";
import { ISelectedSocialMedia, KnownAction, REPIQ_SELECTED_SOCIAL_MEDIA } from "./types";

export const actionCreators = {
    setSelectedSocialMedia:
        (data: ISelectedSocialMedia): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            dispatch({ type: REPIQ_SELECTED_SOCIAL_MEDIA, selectedSocialMedia: data });
        },
};
